//This file maps from a ribbon id to a MenuItemType (command) id
import { RibbonId } from './ribbonId';
import { MenuItemType } from 'owa-mail-filterable-menu-behavior';

const MailRibbonIdToCmdIdMap: Map<RibbonId, MenuItemType> = new Map([
    [RibbonId.AddressBook, MenuItemType.BadItemType],
    [RibbonId.Archive, MenuItemType.Archive],
    [RibbonId.AssignPolicy, MenuItemType.Ribbon_AssignPolicy],
    [RibbonId.Block, MenuItemType.Block],
    [RibbonId.BrowseGroups, MenuItemType.BadItemType],
    [RibbonId.Categorize, MenuItemType.Categories],
    [RibbonId.CreateRule, MenuItemType.InboxRule],
    [RibbonId.DeleteItem, MenuItemType.Ribbon_Delete],
    [RibbonId.FlagUnflag, MenuItemType.Ribbon_FlagUnflag],
    [RibbonId.GetAddIns, MenuItemType.BadItemType],
    [RibbonId.Group_Find, MenuItemType.BadItemType],
    [RibbonId.Group_Groups, MenuItemType.BadItemType],
    [RibbonId.Group_Move, MenuItemType.BadItemType],
    [RibbonId.Group_QuickSteps, MenuItemType.BadItemType],
    [RibbonId.Group_Tags, MenuItemType.BadItemType],
    [RibbonId.IgnoreStopIgnore, MenuItemType.Ribbon_IgnoreStopIgnore],
    [RibbonId.ImmersiveReader, MenuItemType.ShowInImmersiveReader],
    [RibbonId.Insights, MenuItemType.SingleSelection],
    [RibbonId.JunkFlyout, MenuItemType.Ribbon_JunkNotJunk],
    [RibbonId.JunkNotJunk, MenuItemType.Ribbon_JunkNotJunk],
    [RibbonId.MarkComplete, MenuItemType.BadItemType],
    [RibbonId.Move, MenuItemType.Move],
    [RibbonId.NewEvent, MenuItemType.BadItemType],
    [RibbonId.NewGroup, MenuItemType.BadItemType],
    [RibbonId.NewItems, MenuItemType.BadItemType],
    [RibbonId.NewMessage, MenuItemType.Ribbon_NewMessage],
    [RibbonId.NewMessageSplitButton, MenuItemType.BadItemType],
    [RibbonId.NewNote, MenuItemType.Ribbon_NewNote],
    [RibbonId.NewTask, MenuItemType.BadItemType],
    [RibbonId.OtherFolder, MenuItemType.BadItemType],
    [RibbonId.PinUnpin, MenuItemType.Ribbon_PinUnpin],
    [RibbonId.Print, MenuItemType.Print],
    [RibbonId.ReadAloud, MenuItemType.SingleSelection],
    [RibbonId.ReadUnread, MenuItemType.Ribbon_ReadUnread],
    [RibbonId.ReplyWithMeeting, MenuItemType.ReplyWithMeeting],
    [RibbonId.ReportMessage, MenuItemType.SingleSelection],
    [RibbonId.RespondForward, MenuItemType.Ribbon_Forward],
    [RibbonId.RespondReply, MenuItemType.Ribbon_Reply],
    [RibbonId.RespondReplyAll, MenuItemType.Ribbon_ReplyAll],
    [RibbonId.SetQuickActions, MenuItemType.BadItemType],
    [RibbonId.ShowMessageOptions, MenuItemType.EnterpriseOnly],
    [RibbonId.Snooze, MenuItemType.Schedule],
    [RibbonId.Sweep, MenuItemType.Ribbon_Sweep],
    [RibbonId.Undo, MenuItemType.Ribbon_Undo],
    [RibbonId.Unsnooze, MenuItemType.BadItemType],
]);

export const getCmdIdFromRibbonId = (buttonId: RibbonId): number => {
    // The map may not contain btnIdentifier, and the resulting commandId would be undefined. Check for that.
    return MailRibbonIdToCmdIdMap.get(buttonId) ?? MenuItemType.BadItemType;
};
